var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.addData}},[_vm._v("Analytics"),_c('span',{staticClass:"badge badge-warning ml-1"},[_vm._v("BETA")])])}
var staticRenderFns = []

export { render, staticRenderFns }